export const orderKeys = {
  all: (restaurantId: string) => ['orders', restaurantId] as const,
  list: (restaurantId: string, filters?: Record<string, unknown>) =>
    ['orders', restaurantId, 'list', filters ?? {}] as const,
  summary: (restaurantId: string) => ['orders', restaurantId, 'summary'] as const,
  // Distinct from list(status:PENDING): the badge caches a NUMBER, the list
  // caches the full response - sharing a key made the list read the number and
  // render empty.
  pendingCount: (restaurantId: string) => ['orders', restaurantId, 'pending-count'] as const,
  awaitingPayment: (restaurantId: string) => ['orders', restaurantId, 'awaiting-payment'] as const,
  detail: (restaurantId: string, orderId: string) => ['orders', restaurantId, orderId] as const,
};
